import React from 'react';
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from '@/components/ui/accordion';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import useIsMobile from '@/hooks/useIsMobile';

const FAQ = () => {
  const isMobile = useIsMobile();
  const { t } = useTranslation();
  const faqs = t('faq.items', { returnObjects: true });

  return (
    <section className="bg-[#0A0A0A] py-20 px-4">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <p className="text-xs uppercase tracking-[0.2em] text-[#EAB308] font-semibold mb-3">{t('faq.label')}</p>
          <h2 className="text-3xl sm:text-4xl font-light text-white tracking-tight" style={{ fontFamily: 'Outfit, sans-serif' }}>
            {t('faq.title')}
          </h2>
          <p className="text-[#A3A3A3] mt-3 text-base">
            {t('faq.subtitle')}
          </p>
        </div>

        <motion.div
          {...(!isMobile && { initial: { opacity: 0 }, whileInView: { opacity: 1 }, viewport: { once: true }, transition: { duration: 0.5 } })}
        >
          <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
            {faqs.map((faq, i) => (
              <AccordionItem
                key={faq.q}
                value={faq.q}
                data-testid={`faq-item-${i}`}
                className="bg-[#1A1A1A] border border-white/8 rounded-xl px-5 overflow-hidden"
              >
                <AccordionTrigger className="text-white hover:no-underline hover:text-[#EAB308] text-sm sm:text-base font-medium py-5 text-left">
                  {faq.q}
                </AccordionTrigger>
                <AccordionContent className="text-[#A3A3A3] text-sm leading-relaxed pb-5">
                  {faq.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};

export default FAQ;
